import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import AppV2 from "@/AppV2";
import { initAnalyticsIfConsented } from "@/lib/analytics";

// Redirect to www if on root domain this is only used in production
if (window.location.hostname === "creativorare.com") {
  window.location.replace(
    "https://www.creativorare.com" +
      window.location.pathname +
      window.location.search +
      window.location.hash
  );
}

if (new URLSearchParams(window.location.search).has("v2")) {
  sessionStorage.setItem("creativorare-preview-v2", "true");
}

const isV2Preview =
  process.env.REACT_APP_PREVIEW_V2 === "true" ||
  new URLSearchParams(window.location.search).has("v2") ||
  sessionStorage.getItem("creativorare-preview-v2") === "true" ||
  (process.env.NODE_ENV === "development" &&
    process.env.REACT_APP_USE_PRODUCTION_APP !== "true");

const RootApp = isV2Preview ? AppV2 : App;

initAnalyticsIfConsented();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RootApp />
  </React.StrictMode>
);
